import { useQuery } from '@gogame/query';

import { loadRelease } from '../sources/news';
import { release } from './queryKeyFactory';

export const useLoadRelease = () => {
  return useQuery(release.all(), (_, { signal }) =>
    loadRelease({}, { signal })
  );
};
